// SocialCard
import React from 'react';
import Link from 'next/link';
import ROUTES from 'config/routes';
import Icon from 'components/common/Icon';
import { SOCIAL_PROVIDERS } from 'constants/registration';
import styles from './SocialCard.module.sass';
import { CreatorProfileType } from 'types/profile';
import { SocialLink } from 'types/creator';

export interface SocialCardProps {
  socialLinks: Array<SocialLink>;
  profileType: CreatorProfileType;
  trackEditProfileClick: () => void;
}

const SocialCard: React.FC<SocialCardProps> = ({
  socialLinks,
  profileType,
  trackEditProfileClick,
}) => {
  return (
    <div className={styles.socialCard}>
      {profileType === 'personal' && (
        <Link passHref href={ROUTES.AccountSettings.getPath()} legacyBehavior>
          <p
            onClick={trackEditProfileClick}
            id="socials"
            className={styles.editButton}
          >
            Edit
          </p>
        </Link>
      )}
      <h5>Social Accounts</h5>
      {socialLinks.map(({ url, social }) => (
        <SocialAccount key={social} type={social} url={url} />
      ))}
    </div>
  );
};

export default SocialCard;

interface SocialAccountProps {
  type: SOCIAL_PROVIDERS;
  url: string;
}

const SocialAccount: React.FC<SocialAccountProps> = ({ type, url }) => {
  const imgSrc = type !== 'website' ? `/images/icons/${type}.svg` : undefined;

  return (
    <a
      href={`//${
        type !== 'instagram'
          ? url.replace(/(https|http):\/\//, '')
          : `instagram.com/${url}`
      }`}
      target="_blank"
      rel="noreferrer"
      className={styles.socialItem}
    >
      <div className={styles.socialLogo}>
        {typeof imgSrc !== 'undefined' ? (
          <img src={imgSrc} alt={type} />
        ) : (
          <Icon name="web-development" />
        )}
      </div>
      <p>{url}</p>
    </a>
  );
};
